"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  TOKEN_COMPANY_FIELD: true,
  TOKEN_EMPLOYEE_FIELD: true,
  TOKEN_EMAIL_FIELD: true,
  getCountriesList: true,
  getUserDetails: true,
  getAccessLevel: true,
  hasAccountHolder: true,
  getAllPayRoles: true,
  hasCardHolder: true,
  getUserRolesForAccount: true,
  getCompanyDetails: true,
  getLocationResults: true,
  getRegistrationQuestionsWithAnswers: true,
  getCookieConsentInfo: true,
  getEmployees: true,
  getEmployeeDetails: true,
  getProfileDetails: true,
  getCommonIcons: true,
  getPostCodeAddresses: true,
  getAccountList: true,
  getServerUnleashToggles: true,
  getRandomTracingId: true,
  getActivePath: true,
  getLocaleByPathname: true,
  getCountryLanguageByLocale: true,
  getInnBusinessServerSideProps: true,
  getHotelInformationIB: true,
  getHotelAvailabilitiesIB: true,
  staticHotelInformationIB: true,
  roomDefaultValueIfError: true,
  getDaysInMonth: true,
  getCountryName: true,
  getFormattedAddress: true,
  getEmployeesCSV: true,
  getCompanyRegistrationQuestionsAndAnswers: true,
  getContactPreferences: true,
  downloadFromS3PreSignedUrl: true,
  getSelectedAccountHolder: true,
  getManagementInformationReport: true,
  getEmergencyReport: true,
  getSpendingSummary: true,
  getAllPibaCards: true,
  getCompanySpending: true,
  getUpcomingBookings: true,
  getUpcomingSpending: true,
  getPaymentCards: true,
  companyDetailsLookup: true,
  getPayApplications: true,
  getNotifications: true,
  getWorldlineUserPreferences: true,
  getAppLookupData: true,
  getSearchRules: true,
  getPayApplicationDetails: true,
  getActivationDetails: true,
  getRegistrationInfo: true,
  MANAGE_TABS: true,
  getAvailableTabs: true,
  getWorldlineReturnUrl: true,
  getMarketingPreferences: true,
  getSpendOverTimeCSV: true,
  getAccountSpending: true,
  getOutOfPolicyReport: true,
  getIBActivationDetails: true,
  getEmployeesWithFilteringOptions: true,
  getBusinessBookerIpHeaders: true,
  appPreCheck: true,
  getEmployeeDataforUserPilot: true,
  getDetailsFromToken: true,
  getStatementsPdf: true
};
exports.getActivationDetails = exports.getAccountSpending = exports.getAccountList = exports.getAccessLevel = exports.downloadFromS3PreSignedUrl = exports.companyDetailsLookup = exports.appPreCheck = exports.TOKEN_EMPLOYEE_FIELD = exports.TOKEN_EMAIL_FIELD = exports.TOKEN_COMPANY_FIELD = exports.MANAGE_TABS = void 0;
exports.getActivePath = getActivePath;
exports.getAppLookupData = exports.getAllPibaCards = exports.getAllPayRoles = void 0;
exports.getAvailableTabs = getAvailableTabs;
exports.hasCardHolder = exports.hasAccountHolder = exports.getWorldlineUserPreferences = exports.getWorldlineReturnUrl = exports.getUserRolesForAccount = exports.getUserDetails = exports.getUpcomingSpending = exports.getUpcomingBookings = exports.getStatementsPdf = exports.getSpendingSummary = exports.getSpendOverTimeCSV = exports.getServerUnleashToggles = exports.getSelectedAccountHolder = exports.getSearchRules = exports.getRegistrationQuestionsWithAnswers = exports.getRegistrationInfo = exports.getRandomTracingId = exports.getProfileDetails = exports.getPostCodeAddresses = exports.getPaymentCards = exports.getPayApplications = exports.getPayApplicationDetails = exports.getOutOfPolicyReport = exports.getNotifications = exports.getMarketingPreferences = exports.getManagementInformationReport = exports.getLocationResults = exports.getLocaleByPathname = exports.getInnBusinessServerSideProps = exports.getIBActivationDetails = exports.getHotelInformationIB = exports.getHotelAvailabilitiesIB = exports.getFormattedAddress = exports.getEmployeesWithFilteringOptions = exports.getEmployeesCSV = exports.getEmployees = exports.getEmployeeDetails = exports.getEmployeeDataforUserPilot = exports.getEmergencyReport = exports.getDetailsFromToken = exports.getDaysInMonth = exports.getCountryName = exports.getCountryLanguageByLocale = exports.getCountriesList = exports.getCookieConsentInfo = exports.getContactPreferences = exports.getCompanySpending = exports.getCompanyRegistrationQuestionsAndAnswers = exports.getCompanyDetails = exports.getCommonIcons = exports.getBusinessBookerIpHeaders = void 0;
exports.roomDefaultValueIfError = roomDefaultValueIfError;
exports.staticHotelInformationIB = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _ = require("..");
var _api = require("@whitbread-eos/api");
var _nanoid = require("nanoid");
var _headers = require("next/headers");
var _decodeIdToken = _interopRequireDefault(require("../../utils/decodeIdToken"));
var _unleash = require("../../utils/unleash");
var _helpers = require("../helpers");
var _queries = require("./queries");
Object.keys(_queries).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _queries[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _queries[key];
    }
  });
});
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TOKEN_COMPANY_FIELD = exports.TOKEN_COMPANY_FIELD = 'https://premierinn.com/companyAccountId';
var TOKEN_EMPLOYEE_FIELD = exports.TOKEN_EMPLOYEE_FIELD = 'https://premierinn.com/employeeAccountId';
var TOKEN_EMAIL_FIELD = exports.TOKEN_EMAIL_FIELD = 'https://premierinn.com/email';
var getCountriesList = exports.getCountriesList = function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (language) {
    return yield (0, _.executeGraphQLQuery)(_api.GET_COUNTRIES, {
      language,
      country: language === 'en' ? 'gb' : 'de',
      site: 'business-booker'
    }, result => {
      var _result$data;
      return result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 || (_result$data = _result$data.countries) === null || _result$data === void 0 ? void 0 : _result$data.countries;
    });
  });
  return function getCountriesList(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getUserDetails = exports.getUserDetails = function () {
  var _ref2 = (0, _asyncToGenerator2.default)(function* (token) {
    var revalidateCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      email
    } = (0, _decodeIdToken.default)(token);
    if (!email) {
      return null;
    }
    return getProfileDetails(email, token, revalidateCache, headers);
  });
  return function getUserDetails(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var getAccessLevel = exports.getAccessLevel = function () {
  var _ref3 = (0, _asyncToGenerator2.default)(function* (accountHolderNumber) {
    var _cookies$get$value, _cookies$get, _userDetails$business, _userDetails$business2, _selectedAccountHolde, _selectedAccountHolde2;
    var token = (_cookies$get$value = (_cookies$get = (0, _headers.cookies)().get(_.ID_TOKEN_COOKIE)) === null || _cookies$get === void 0 ? void 0 : _cookies$get.value) !== null && _cookies$get$value !== void 0 ? _cookies$get$value : '';
    var [userDetails = null, accounts = []] = yield Promise.all([getUserDetails(token), getAccountList(token)]);
    var accessLevel = userDetails === null || userDetails === void 0 || (_userDetails$business = userDetails.business) === null || _userDetails$business === void 0 ? void 0 : _userDetails$business.accessLevel;
    var selectedAccountHolder = accountHolderNumber ? getSelectedAccountHolder(accounts, accountHolderNumber) : accounts === null || accounts === void 0 ? void 0 : accounts[0];
    return {
      accessLevel,
      isTravelManager: accessLevel === _api.BUSINESS_BOOKER_USER_ROLES.SUPER,
      isBooker: accessLevel === _api.BUSINESS_BOOKER_USER_ROLES.BOOKER,
      isSelfBooker: accessLevel === _api.BUSINESS_BOOKER_USER_ROLES.SELF,
      isGuest: accessLevel === _api.BUSINESS_BOOKER_USER_ROLES.STAYER,
      isTethered: !!(userDetails !== null && userDetails !== void 0 && (_userDetails$business2 = userDetails.business) !== null && _userDetails$business2 !== void 0 && _userDetails$business2.tethered) && accounts.length > 0,
      hasAccountHolder: hasAccountHolder(accounts),
      hasCardHolder: hasCardHolder(accounts),
      selectedAccount: {
        isCardHolder: !!(selectedAccountHolder !== null && selectedAccountHolder !== void 0 && (_selectedAccountHolde = selectedAccountHolder.registrationRoles) !== null && _selectedAccountHolde !== void 0 && _selectedAccountHolde.includes(_api.RegistrationRole.CardHolder)),
        isAccountHolder: !!(selectedAccountHolder !== null && selectedAccountHolder !== void 0 && (_selectedAccountHolde2 = selectedAccountHolder.registrationRoles) !== null && _selectedAccountHolde2 !== void 0 && _selectedAccountHolde2.includes(_api.RegistrationRole.AccountHolder))
      }
    };
  });
  return function getAccessLevel(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
var hasAccountHolder = accountList => {
  return !!(accountList && accountList.some(x => {
    var _x$registrationRoles;
    return (_x$registrationRoles = x.registrationRoles) === null || _x$registrationRoles === void 0 ? void 0 : _x$registrationRoles.includes(_api.RegistrationRole.AccountHolder);
  }));
};
exports.hasAccountHolder = hasAccountHolder;
var getAllPayRoles = accountList => {
  if (!accountList) return [];
  return Array.from(new Set(accountList.flatMap(account => {
    var _account$registration;
    return (_account$registration = account.registrationRoles) !== null && _account$registration !== void 0 ? _account$registration : [];
  })));
};
exports.getAllPayRoles = getAllPayRoles;
var hasCardHolder = accountList => {
  return !!(accountList && accountList.some(x => {
    var _x$registrationRoles2;
    return (_x$registrationRoles2 = x.registrationRoles) === null || _x$registrationRoles2 === void 0 ? void 0 : _x$registrationRoles2.includes(_api.RegistrationRole.CardHolder);
  }));
};
exports.hasCardHolder = hasCardHolder;
var getUserRolesForAccount = exports.getUserRolesForAccount = function () {
  var _ref4 = (0, _asyncToGenerator2.default)(function* (account) {
    try {
      var _cookies$get$value2, _cookies$get2, _userDetails$business3, _account$registration2;
      var token = (_cookies$get$value2 = (_cookies$get2 = (0, _headers.cookies)().get(_.ID_TOKEN_COOKIE)) === null || _cookies$get2 === void 0 ? void 0 : _cookies$get2.value) !== null && _cookies$get$value2 !== void 0 ? _cookies$get$value2 : '';
      var userDetails = yield getUserDetails(token);
      var accessLevel = userDetails === null || userDetails === void 0 || (_userDetails$business3 = userDetails.business) === null || _userDetails$business3 === void 0 ? void 0 : _userDetails$business3.accessLevel;
      return {
        wl: (_account$registration2 = account === null || account === void 0 ? void 0 : account.registrationRoles) !== null && _account$registration2 !== void 0 ? _account$registration2 : [],
        bb: accessLevel ? [accessLevel] : []
      };
    } catch (_unused) {
      return {
        wl: [],
        bb: []
      };
    }
  });
  return function getUserRolesForAccount(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
var getCompanyDetails = exports.getCompanyDetails = function () {
  var _ref5 = (0, _asyncToGenerator2.default)(function* (companyId, token) {
    var revalidateCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return yield (0, _.executeGraphQLQuery)((0, _api.getCompanyDetailsQuery)(), {
      companyId
    }, result => {
      var _result$data2;
      return result === null || result === void 0 || (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.companyDetails;
    }, token, revalidateCache);
  });
  return function getCompanyDetails(_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();
var getLocationResults = exports.getLocationResults = function () {
  var _ref6 = (0, _asyncToGenerator2.default)(function* (value) {
    var includeHotels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var url = "".concat(process.env.NEXT_PUBLIC_SNOWDROP_BASE_URL, "v1/autocomplete?input=/").concat(value, "&gplaces[components]=country:uk|country:de");
    if (includeHotels) {
      url += '&hotels.limit=100';
    }
    var response = yield fetch(url);
    return response.json();
  });
  return function getLocationResults(_x7) {
    return _ref6.apply(this, arguments);
  };
}();
var getRegistrationQuestionsWithAnswers = exports.getRegistrationQuestionsWithAnswers = function () {
  var _ref7 = (0, _asyncToGenerator2.default)(function* (employeeId) {
    var _cookies$get$value3, _cookies$get3;
    var token = (_cookies$get$value3 = (_cookies$get3 = (0, _headers.cookies)().get(_.ID_TOKEN_COOKIE)) === null || _cookies$get3 === void 0 ? void 0 : _cookies$get3.value) !== null && _cookies$get$value3 !== void 0 ? _cookies$get$value3 : '';
    var {
      companyId
    } = getDetailsFromToken(token);
    return yield (0, _.executeGraphQLQuery)((0, _api.getRegistrationQuestionsQuery)(), {
      companyId,
      employeeId
    }, result => {
      var _result$data3;
      return (0, _.parseRegistrationQuestions)(result === null || result === void 0 || (_result$data3 = result.data) === null || _result$data3 === void 0 ? void 0 : _result$data3.getEmployeeRegistrationQuestionsAndAnswers);
    }, token, true);
  });
  return function getRegistrationQuestionsWithAnswers(_x8) {
    return _ref7.apply(this, arguments);
  };
}();
var getCookieConsentInfo = exports.getCookieConsentInfo = function () {
  var _ref8 = (0, _asyncToGenerator2.default)(function* (country, language, brand) {
    return yield (0, _.executeGraphQLQuery)(_api.GET_COOKIE_CONSENT_INFO, {
      country,
      language,
      brand
    }, result => result === null || result === void 0 ? void 0 : result.data);
  });
  return function getCookieConsentInfo(_x9, _x10, _x11) {
    return _ref8.apply(this, arguments);
  };
}();
var getEmployees = exports.getEmployees = function () {
  var _ref9 = (0, _asyncToGenerator2.default)(function* (companyId, size, token, page, searchCriteria, pageToken, bookingChannel, awaitingApproval, employeeId) {
    return yield (0, _.executeGraphQLQuery)((0, _api.getEmployeesQuery)(), {
      companyId,
      size,
      page,
      searchCriteria,
      pageToken,
      bookingChannel,
      awaitingApproval,
      employeeId
    }, result => {
      var _result$data4;
      return result === null || result === void 0 || (_result$data4 = result.data) === null || _result$data4 === void 0 ? void 0 : _result$data4.getEmployees;
    }, token, true);
  });
  return function getEmployees(_x12, _x13, _x14, _x15, _x16, _x17, _x18, _x19, _x20) {
    return _ref9.apply(this, arguments);
  };
}();
var getEmployeeDetails = exports.getEmployeeDetails = function () {
  var _ref10 = (0, _asyncToGenerator2.default)(function* (companyId, employeeId, token) {
    return yield (0, _.executeGraphQLQuery)((0, _api.getEmployeeByIdQuery)(), {
      companyId,
      employeeId
    }, result => {
      var _result$data5;
      return result === null || result === void 0 || (_result$data5 = result.data) === null || _result$data5 === void 0 ? void 0 : _result$data5.getEmployeeDetails;
    }, token, true);
  });
  return function getEmployeeDetails(_x21, _x22, _x23) {
    return _ref10.apply(this, arguments);
  };
}();
var getProfileDetails = exports.getProfileDetails = function () {
  var _ref11 = (0, _asyncToGenerator2.default)(function* (customerId, token) {
    var revalidateCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return yield (0, _.executeGraphQLQuery)((0, _api.getProfileDetailsQuery)(), {
      customerId,
      business: true,
      innBusiness: true
    }, result => {
      var _result$data6;
      return result === null || result === void 0 || (_result$data6 = result.data) === null || _result$data6 === void 0 ? void 0 : _result$data6.getProfileDetails;
    }, token, revalidateCache, false, headers);
  });
  return function getProfileDetails(_x24, _x25) {
    return _ref11.apply(this, arguments);
  };
}();
var getCommonIcons = exports.getCommonIcons = function () {
  var _ref12 = (0, _asyncToGenerator2.default)(function* (language) {
    var data = yield (0, _.executeGraphQLQuery)((0, _api.getInnBusinessCommonIcons)(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data7;
      return result === null || result === void 0 || (_result$data7 = result.data) === null || _result$data7 === void 0 || (_result$data7 = _result$data7.getPageData) === null || _result$data7 === void 0 ? void 0 : _result$data7.commonIconsEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getCommonIcons(_x26) {
    return _ref12.apply(this, arguments);
  };
}();
var getPostCodeAddresses = exports.getPostCodeAddresses = function () {
  var _ref13 = (0, _asyncToGenerator2.default)(function* (postCode, token) {
    return yield (0, _.executeGraphQLQuery)(_api.GET_ADDRESSES, {
      searchTerm: postCode
    }, result => {
      var _result$data8;
      return result === null || result === void 0 || (_result$data8 = result.data) === null || _result$data8 === void 0 ? void 0 : _result$data8.partialAddress;
    }, token);
  });
  return function getPostCodeAddresses(_x27, _x28) {
    return _ref13.apply(this, arguments);
  };
}();
var getAccountList = exports.getAccountList = function () {
  var _ref14 = (0, _asyncToGenerator2.default)(function* (token) {
    var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var accounts = yield (0, _.executeGraphQLQuery)(_api.GET_ACCOUNT_LIST, {
      viewAll: false
    }, result => {
      var _result$data9;
      return result === null || result === void 0 || (_result$data9 = result.data) === null || _result$data9 === void 0 || (_result$data9 = _result$data9.getAccountList) === null || _result$data9 === void 0 ? void 0 : _result$data9.accounts;
    }, token, true, false, headers);
    return accounts === null || accounts === void 0 ? void 0 : accounts.filter(account => account.accountNumber);
  });
  return function getAccountList(_x29) {
    return _ref14.apply(this, arguments);
  };
}();
var getServerUnleashToggles = exports.getServerUnleashToggles = function () {
  var _ref15 = (0, _asyncToGenerator2.default)(function* (label, fallbackFlags, url, query) {
    var _tracingCookie$name;
    var cookieStore = (0, _headers.cookies)();
    var tracingCookie = cookieStore.get(_.DEFAULT_TRACING_COOKIE_NAME);
    return (0, _unleash.getUnleashTogglesServerOrClient)(cookieStore, label, fallbackFlags, url, query, {
      [_.DEFAULT_TRACING_COOKIE_NAME]: (_tracingCookie$name = tracingCookie === null || tracingCookie === void 0 ? void 0 : tracingCookie.name) !== null && _tracingCookie$name !== void 0 ? _tracingCookie$name : ''
    });
  });
  return function getServerUnleashToggles(_x30, _x31, _x32, _x33) {
    return _ref15.apply(this, arguments);
  };
}();
var getRandomTracingId = () => {
  return (0, _nanoid.nanoid)();
};
exports.getRandomTracingId = getRandomTracingId;
function getActivePath(currentPath, navObj) {
  var _Object$values$find$l, _Object$values;
  return (_Object$values$find$l = (_Object$values = Object.values(navObj)) === null || _Object$values === void 0 || (_Object$values = _Object$values.find(value => currentPath === null || currentPath === void 0 ? void 0 : currentPath.includes(value === null || value === void 0 ? void 0 : value.path))) === null || _Object$values === void 0 ? void 0 : _Object$values.label) !== null && _Object$values$find$l !== void 0 ? _Object$values$find$l : '';
}
var getLocaleByPathname = pathname => {
  var segments = pathname.split('/');
  var locale = segments[1].toLowerCase();
  var mappedLocale = {
    en: _api.LOCALES.EN,
    gb: _api.LOCALES.EN,
    de: _api.LOCALES.DE
  };
  return mappedLocale[locale] || locale;
};
exports.getLocaleByPathname = getLocaleByPathname;
var getCountryLanguageByLocale = locale => {
  if (locale === _api.CountryCode.DE) {
    return {
      country: _api.CountryCode.DE,
      language: _api.CountryCode.DE
    };
  }
  return {
    country: locale === _api.LOCALES.DE ? _api.CountryCode.DE : _api.CountryCode.GB,
    language: locale === _api.LOCALES.DE ? _api.CountryCode.DE : _api.CountryCode.EN
  };
};
exports.getCountryLanguageByLocale = getCountryLanguageByLocale;
var getInnBusinessServerSideProps = exports.getInnBusinessServerSideProps = function () {
  var _ref16 = (0, _asyncToGenerator2.default)(function* (token, language) {
    var needsFooter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var businessBookerRequestHeaders = arguments.length > 3 ? arguments[3] : undefined;
    try {
      var headers = businessBookerRequestHeaders ? getBusinessBookerIpHeaders(businessBookerRequestHeaders) : undefined;
      var footerPromise = needsFooter ? (0, _.getFooterLabels)(language) : Promise.resolve(undefined);
      var {
        companyId
      } = getDetailsFromToken(token);
      var [userDetails, labels, icons, cards, accounts, users, spending, searchRules, layout, companyDetails, notifications, footer] = yield Promise.all([getUserDetails(token, false, headers), (0, _.getInnBusinessHeaderLabels)(language), getCommonIcons(language), (0, _.getCardManagementLabels)(language), getAccountList(token, headers), (0, _.getUserManagementLabels)(language), (0, _.getSpendingLabels)(language), getSearchRules(token), (0, _.getInnBusinessLayoutLabels)(language), getCompanyDetails(companyId, token), (0, _.getNotificationsLabels)(language), footerPromise]);
      return {
        labels,
        icons,
        cards,
        users,
        spending,
        userDetails,
        companyDetails,
        footer: footer !== null && footer !== void 0 ? footer : null,
        language,
        isAccountHolder: hasAccountHolder(accounts),
        isCardHolder: hasCardHolder(accounts),
        searchRules,
        layout,
        notifications
      };
    } catch (_unused2) {
      return null;
    }
  });
  return function getInnBusinessServerSideProps(_x34, _x35) {
    return _ref16.apply(this, arguments);
  };
}();
var getHotelInformationIB = exports.getHotelInformationIB = function () {
  var _ref17 = (0, _asyncToGenerator2.default)(function* (hotelId, language) {
    return yield (0, _.executeGraphQLQuery)(_api.GET_HOTEL_INFORMATION, {
      hotelId,
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data10;
      return result === null || result === void 0 || (_result$data10 = result.data) === null || _result$data10 === void 0 ? void 0 : _result$data10.hotelInformation;
    });
  });
  return function getHotelInformationIB(_x36, _x37) {
    return _ref17.apply(this, arguments);
  };
}();
var getHotelAvailabilitiesIB = exports.getHotelAvailabilitiesIB = function () {
  var _ref18 = (0, _asyncToGenerator2.default)(function* (hotelId, arrival, departure, brand, country, rooms, language, bookingChannel, channel, token) {
    return yield (0, _.executeGraphQLQuery)(_api.HOTEL_AVAILABILITY_QUERY, {
      hotelId,
      arrival,
      departure,
      brand,
      country,
      rooms,
      language,
      bookingChannel,
      channel
    }, result => result === null || result === void 0 ? void 0 : result.data, token);
  });
  return function getHotelAvailabilitiesIB(_x38, _x39, _x40, _x41, _x42, _x43, _x44, _x45, _x46, _x47) {
    return _ref18.apply(this, arguments);
  };
}();
var staticHotelInformationIB = exports.staticHotelInformationIB = (0, _helpers.cachePromise)(function () {
  var _ref19 = (0, _asyncToGenerator2.default)(function* (slug, language) {
    return yield (0, _.executeGraphQLQuery)(_api.STATIC_HOTEL_INFORMATION_QUERY, {
      slug,
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data11;
      return result === null || result === void 0 || (_result$data11 = result.data) === null || _result$data11 === void 0 ? void 0 : _result$data11.hotelInformationBySlug;
    });
  });
  return function (_x48, _x49) {
    return _ref19.apply(this, arguments);
  };
}());
function roomDefaultValueIfError(rooms) {
  var defaultValue = {
    adultsNumber: _api.DEFAULT_NUMBER,
    childrenNumber: 0,
    type: _api.ROOM_CODES.double
  };
  if (rooms.length === 0) {
    return [_objectSpread({}, defaultValue)];
  }
  var hasInvalidValue = rooms.some(room => {
    return (0, _.validateRoomOccupancyConditions)(room.adultsNumber.toString(), room.childrenNumber.toString(), room.type);
  });
  if (hasInvalidValue) {
    return [_objectSpread({}, defaultValue)];
  }
  return rooms;
}
var getDaysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
};
exports.getDaysInMonth = getDaysInMonth;
var getCountryName = (countryCode, countries) => {
  if (countryCode === 'D') {
    countryCode = _api.ShortCountry.DE;
  }
  var country = countries.find(country => country.countryCode === countryCode);
  return country && country.countryName;
};
exports.getCountryName = getCountryName;
var getFormattedAddress = exports.getFormattedAddress = function () {
  var _ref20 = (0, _asyncToGenerator2.default)(function* (addressId) {
    return yield (0, _.executeGraphQLQuery)(_api.GET_FORMATTED_ADDRESS, {
      identifier: encodeURIComponent(addressId)
    }, result => {
      var _result$data12;
      return result === null || result === void 0 || (_result$data12 = result.data) === null || _result$data12 === void 0 ? void 0 : _result$data12.formattedAddress;
    });
  });
  return function getFormattedAddress(_x50) {
    return _ref20.apply(this, arguments);
  };
}();
var getEmployeesCSV = exports.getEmployeesCSV = function () {
  var _ref21 = (0, _asyncToGenerator2.default)(function* (token, companyId) {
    if (!companyId) {
      return null;
    }
    try {
      yield fetch("".concat(process.env.NEXT_PUBLIC_REST_API, "/companies/").concat(companyId, "/employees/bulk"), {
        method: 'GET',
        headers: {
          Authorization: "Bearer ".concat(token)
        },
        cache: 'no-cache'
      }).then(data => data.blob()).then(response => (0, _.resolveAndDownloadBlob)(response, 'Employees', '.csv'));
    } catch (error) {
      return null;
    }
  });
  return function getEmployeesCSV(_x51, _x52) {
    return _ref21.apply(this, arguments);
  };
}();
var getCompanyRegistrationQuestionsAndAnswers = exports.getCompanyRegistrationQuestionsAndAnswers = function () {
  var _ref22 = (0, _asyncToGenerator2.default)(function* (companyId, headers) {
    var _cookies$get$value4, _cookies$get4;
    var token = (_cookies$get$value4 = (_cookies$get4 = (0, _headers.cookies)().get(_.ID_TOKEN_COOKIE)) === null || _cookies$get4 === void 0 ? void 0 : _cookies$get4.value) !== null && _cookies$get$value4 !== void 0 ? _cookies$get$value4 : '';
    try {
      var res = yield (0, _.executeGraphQLQuery)((0, _api.getCompanyRegistrationQuestionsQuery)(), {
        companyId
      }, result => {
        var _result$data13;
        return (0, _.parseRegistrationQuestions)(result === null || result === void 0 || (_result$data13 = result.data) === null || _result$data13 === void 0 ? void 0 : _result$data13.getCompanyRegistrationQuestionsAndAnswers);
      }, token, true, true, headers);
      return res;
    } catch (error) {
      throw new Error('Error fetching company registration questions and answers');
    }
  });
  return function getCompanyRegistrationQuestionsAndAnswers(_x53, _x54) {
    return _ref22.apply(this, arguments);
  };
}();
var DEFAULT_CONTACT_PREFERENCE = email => ({
  permissions: [{
    brandCode: _api.BRANDCODES[0],
    brand: 'Premier Inn',
    optIn: false,
    secondOptInReq: null,
    secondOptIn: null,
    secondPartyOptIn: false,
    thirdPartyVendorsOptIn: false,
    suppressMarketingCheckbox: false
  }],
  loyaltyAccounts: [],
  valid: true,
  deleted: false,
  contactChannelId: null,
  contactChannelValue: email
});
var getContactPreferences = exports.getContactPreferences = function () {
  var _ref23 = (0, _asyncToGenerator2.default)(function* (email, token, countryOfResidence, language) {
    if (!token) {
      throw new Error('Authentication token is required');
    }
    if (!email) {
      throw new Error('Email is required');
    }
    var variables = {
      request: {
        contactType: 'email',
        contactValue: email,
        brandCodes: _api.BRANDCODES[0],
        business: true,
        contactChannelId: null,
        countryOfResidence,
        language
      }
    };
    try {
      var result = yield (0, _.executeGraphQLQuery)(_api.GET_CONTACT_PREFERENCES, variables, result => {
        if (!(result !== null && result !== void 0 && result.errors)) {
          var _result$data14;
          return result === null || result === void 0 || (_result$data14 = result.data) === null || _result$data14 === void 0 ? void 0 : _result$data14.getContactPreferences;
        }
        var hasAppSyncError = result.errors.some(error => error.message === 'appsync.global.error');
        if (hasAppSyncError) {
          return DEFAULT_CONTACT_PREFERENCE(email);
        }
        return null;
      }, token, true, true);
      return result !== null && result !== void 0 ? result : DEFAULT_CONTACT_PREFERENCE(email);
    } catch (error) {
      return DEFAULT_CONTACT_PREFERENCE(email);
    }
  });
  return function getContactPreferences(_x55, _x56, _x57, _x58) {
    return _ref23.apply(this, arguments);
  };
}();
var downloadFromS3PreSignedUrl = (downloadUrl, fileName) => {
  var anchor = document.createElement('a');
  anchor.href = downloadUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};
exports.downloadFromS3PreSignedUrl = downloadFromS3PreSignedUrl;
var getSelectedAccountHolder = (accounts, accountNumber) => {
  var currentAccount = accounts[0];
  if (accountNumber) {
    var account = accounts.find(account => String(account.tetheredGuid) === accountNumber);
    if (account) {
      currentAccount = account;
    }
  }
  return currentAccount;
};
exports.getSelectedAccountHolder = getSelectedAccountHolder;
var getManagementInformationReport = exports.getManagementInformationReport = function () {
  var _ref24 = (0, _asyncToGenerator2.default)(function* (token, fromDate, toDate, showQnAcolumns, language) {
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var revalidateCache = false;
    var returnErrors = true;
    var response = yield (0, _.executeGraphQLQuery)((0, _api.managementInformationReportQuery)(), {
      fromDate,
      toDate,
      showQnAcolumns,
      language
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getManagementInformationReport(_x59, _x60, _x61, _x62, _x63) {
    return _ref24.apply(this, arguments);
  };
}();
var getEmergencyReport = exports.getEmergencyReport = function () {
  var _ref25 = (0, _asyncToGenerator2.default)(function* (token, language) {
    var revalidateCache = false;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield (0, _.executeGraphQLQuery)((0, _api.emergencyReportQuery)(), {
      language
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getEmergencyReport(_x64, _x65) {
    return _ref25.apply(this, arguments);
  };
}();
var getSpendingSummary = exports.getSpendingSummary = function () {
  var _ref26 = (0, _asyncToGenerator2.default)(function* (token) {
    var viewAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var revalidateCache = false;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield (0, _.executeGraphQLQuery)((0, _api.getAccountBalanceSummary)(), {
      viewAll
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getSpendingSummary(_x66) {
    return _ref26.apply(this, arguments);
  };
}();
var getAllPibaCards = exports.getAllPibaCards = function () {
  var _ref27 = (0, _asyncToGenerator2.default)(function* (token, scheme, tetheredUserId, includeCancelledCards, showMyCards, pageIndex, pageSize) {
    return yield (0, _.executeGraphQLQuery)((0, _api.getAllPibaCards)(), {
      tetheredUserId,
      countryCode: scheme,
      pibaCardsCriteria: {
        userId: tetheredUserId,
        includeCancelledCards,
        showMyCards,
        pageNumber: pageIndex,
        maxRows: pageSize
      }
    }, result => {
      var _result$data15;
      return result === null || result === void 0 || (_result$data15 = result.data) === null || _result$data15 === void 0 ? void 0 : _result$data15.getAllPIBACards;
    }, token, true);
  });
  return function getAllPibaCards(_x67, _x68, _x69, _x70, _x71, _x72, _x73) {
    return _ref27.apply(this, arguments);
  };
}();
var getCompanySpending = exports.getCompanySpending = function () {
  var _ref28 = (0, _asyncToGenerator2.default)(function* (token, fromMonthYear, toMonthYear) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield (0, _.executeGraphQLQuery)((0, _api.getCompanySpendingQuery)(), {
      fromMonthYear,
      toMonthYear
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getCompanySpending(_x74, _x75, _x76) {
    return _ref28.apply(this, arguments);
  };
}();
var getUpcomingBookings = exports.getUpcomingBookings = function () {
  var _ref29 = (0, _asyncToGenerator2.default)(function* (token, params) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield (0, _.executeGraphQLQuery)((0, _api.getUpcomingBookingsQuery)(), params, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getUpcomingBookings(_x77, _x78) {
    return _ref29.apply(this, arguments);
  };
}();
var getUpcomingSpending = exports.getUpcomingSpending = function () {
  var _ref30 = (0, _asyncToGenerator2.default)(function* (token, accountId, tetheredUserGuid) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield (0, _.executeGraphQLQuery)((0, _api.getUpcomingSpendingQuery)(), {
      accountId,
      tetheredUserGuid
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getUpcomingSpending(_x79, _x80, _x81) {
    return _ref30.apply(this, arguments);
  };
}();
var getPaymentCards = exports.getPaymentCards = function () {
  var _ref31 = (0, _asyncToGenerator2.default)(function* (token, companyId) {
    return yield (0, _.executeGraphQLQuery)((0, _api.getPaymentCards)(), {
      companyId
    }, result => {
      var _result$data16;
      return result === null || result === void 0 || (_result$data16 = result.data) === null || _result$data16 === void 0 ? void 0 : _result$data16.getPaymentCards;
    }, token, true);
  });
  return function getPaymentCards(_x82, _x83) {
    return _ref31.apply(this, arguments);
  };
}();
var companyDetailsLookup = exports.companyDetailsLookup = function () {
  var _ref32 = (0, _asyncToGenerator2.default)(function* (token, companyRegistrationNumber, scheme) {
    return yield (0, _.executeGraphQLQuery)((0, _api.companyDetailsLookupQuery)(), {
      companyRegistrationNumber,
      scheme
    }, result => {
      var _result$data17;
      return result === null || result === void 0 || (_result$data17 = result.data) === null || _result$data17 === void 0 ? void 0 : _result$data17.companyDetailsLookup;
    }, token, true);
  });
  return function companyDetailsLookup(_x84, _x85, _x86) {
    return _ref32.apply(this, arguments);
  };
}();
var getPayApplications = exports.getPayApplications = function () {
  var _ref33 = (0, _asyncToGenerator2.default)(function* (token) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield (0, _.executeGraphQLQuery)((0, _api.getPayApplicationsQuery)(), {}, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getPayApplications(_x87) {
    return _ref33.apply(this, arguments);
  };
}();
var getNotifications = exports.getNotifications = function () {
  var _ref34 = (0, _asyncToGenerator2.default)(function* (token, scheme, tetheredUserId) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield (0, _.executeGraphQLQuery)((0, _api.getNotificationsQuery)(), {
      scheme,
      tetheredUserId
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getNotifications(_x88, _x89, _x90) {
    return _ref34.apply(this, arguments);
  };
}();
var formatAccountNumber = accountNumber => {
  if (!accountNumber) return '';
  return accountNumber.replace(/(\d{4})/g, '$1 ').trim();
};
var getWorldlineUserPreferences = exports.getWorldlineUserPreferences = function () {
  var _ref35 = (0, _asyncToGenerator2.default)(function* (token) {
    if (!token) return null;
    try {
      var accounts = yield getAccountList(token);
      if (!(accounts !== null && accounts !== void 0 && accounts.length)) return null;
      var validAccounts = accounts.filter(acc => !!(acc !== null && acc !== void 0 && acc.tetheredGuid) && !!(acc !== null && acc !== void 0 && acc.accountName) && !!(acc !== null && acc !== void 0 && acc.accountNumber) && Array.isArray(acc === null || acc === void 0 ? void 0 : acc.registrationRoles));
      if (!validAccounts.length) return null;
      var preferencesData = yield (0, _.executeGraphQLQuery)(_api.WORLDLINE_USER_PREFERENCES_QUERY, {
        tetheredUserGuids: validAccounts.map(acc => acc.tetheredGuid)
      }, result => {
        var _data;
        return result === null || result === void 0 || (_data = result.data) === null || _data === void 0 ? void 0 : _data.getWorldlineUserPreferences;
      }, token, true, false);
      if (!(preferencesData !== null && preferencesData !== void 0 && preferencesData.length)) return null;
      var accountMap = new Map(validAccounts.map(acc => [acc.tetheredGuid, acc]));
      return preferencesData.map(pref => {
        var account = accountMap.get(pref.tetheredUserGuid);
        if (!account) return null;
        var result = {
          tetheredUserGuid: pref.tetheredUserGuid,
          settings: pref.settings,
          preferenceDetails: pref.details,
          accountName: account.accountName,
          registrationRoles: account.registrationRoles,
          accountNumber: formatAccountNumber(account.accountNumber)
        };
        return result;
      }).filter(item => item !== null);
    } catch (_unused3) {
      return null;
    }
  });
  return function getWorldlineUserPreferences(_x91) {
    return _ref35.apply(this, arguments);
  };
}();
var getAppLookupData = exports.getAppLookupData = function () {
  var _ref36 = (0, _asyncToGenerator2.default)(function* (scheme, token) {
    return yield (0, _.executeGraphQLQuery)(scheme === 'GB' ? _api.getAppLookupDataQueryEN : _api.getAppLookupDataQueryDE, {
      scheme
    }, result => {
      var _result$data18;
      return result === null || result === void 0 || (_result$data18 = result.data) === null || _result$data18 === void 0 ? void 0 : _result$data18.getAppLookupData;
    }, token);
  });
  return function getAppLookupData(_x92, _x93) {
    return _ref36.apply(this, arguments);
  };
}();
var getSearchRules = exports.getSearchRules = function () {
  var _ref37 = (0, _asyncToGenerator2.default)(function* (token) {
    return yield (0, _.executeGraphQLQuery)(_api.GET_SEARCH_RULES_QUERY, {
      channel: 'BB'
    }, result => result === null || result === void 0 ? void 0 : result.data, token);
  });
  return function getSearchRules(_x94) {
    return _ref37.apply(this, arguments);
  };
}();
var getPayApplicationDetails = exports.getPayApplicationDetails = function () {
  var _ref38 = (0, _asyncToGenerator2.default)(function* (token, applicationGuid, applicationId, scheme) {
    return yield (0, _.executeGraphQLQuery)((0, _api.getPayApplicationDetailsQuery)(), {
      applicationGuid,
      applicationId,
      scheme
    }, result => result === null || result === void 0 ? void 0 : result.data.getApplicationDetails, token, true);
  });
  return function getPayApplicationDetails(_x95, _x96, _x97, _x98) {
    return _ref38.apply(this, arguments);
  };
}();
var getActivationDetails = exports.getActivationDetails = function () {
  var _ref39 = (0, _asyncToGenerator2.default)(function* (activationKey) {
    return yield (0, _.executeGraphQLQuery)((0, _api.getActivationDetailsQuery)(), {
      activationKey
    }, result => {
      var _result$data19;
      return result === null || result === void 0 || (_result$data19 = result.data) === null || _result$data19 === void 0 ? void 0 : _result$data19.getActivationDetails;
    });
  });
  return function getActivationDetails(_x99) {
    return _ref39.apply(this, arguments);
  };
}();
var getRegistrationInfo = exports.getRegistrationInfo = function () {
  var _ref40 = (0, _asyncToGenerator2.default)(function* (token, registrationCode) {
    return yield (0, _.executeGraphQLQuery)((0, _api.getRegistrationInfoQuery)(), {
      registrationCode
    }, result => {
      var _result$data20;
      return result === null || result === void 0 || (_result$data20 = result.data) === null || _result$data20 === void 0 ? void 0 : _result$data20.getRegistrationInfo;
    }, token, true);
  });
  return function getRegistrationInfo(_x100, _x101) {
    return _ref40.apply(this, arguments);
  };
}();
var MANAGE_TABS = exports.MANAGE_TABS = {
  INN_BUSINESS: 'innbusiness',
  INN_BUSINESS_PAY: 'innbusiness-pay'
};
function getAvailableTabs(isTravelManager, isTethered, hasAccountHolder) {
  var hasCardHolder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var forCardManagement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isDeLanguage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var isPibaEuroEnabled = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  if (!isTravelManager && !hasAccountHolder && !hasCardHolder) {
    return [];
  }
  var hasOnlyFinanceUser = isTethered && !hasAccountHolder && !hasCardHolder;
  if (isTravelManager && isDeLanguage && !isTethered && !isPibaEuroEnabled) {
    return [MANAGE_TABS.INN_BUSINESS];
  }
  var tabs = new Set();
  if (isTravelManager) {
    tabs.add(MANAGE_TABS.INN_BUSINESS);
    if (!hasOnlyFinanceUser) {
      tabs.add(MANAGE_TABS.INN_BUSINESS_PAY);
    }
  }
  if (forCardManagement) {
    if (isTethered && (hasCardHolder || hasAccountHolder)) {
      tabs.add(MANAGE_TABS.INN_BUSINESS_PAY);
    }
  } else {
    if (isTethered && hasAccountHolder) {
      tabs.add(MANAGE_TABS.INN_BUSINESS_PAY);
    }
  }
  return Array.from(tabs).slice(0, 2);
}
var getWorldlineReturnUrl = (locale, path) => {
  return "".concat(process.env.NEXT_PUBLIC_WORLDLINE_RETURN_URL).concat((0, _.getPathForLocale)(locale, path));
};
exports.getWorldlineReturnUrl = getWorldlineReturnUrl;
var getMarketingPreferences = exports.getMarketingPreferences = function () {
  var _ref41 = (0, _asyncToGenerator2.default)(function* (brandCode, email, countryOfResidence, language) {
    return yield (0, _.executeGraphQLQuery)(_api.GET_ANONYMOUS_NEWSLETTER_PREFERENCES, {
      brandCode,
      email,
      countryOfResidence,
      language
    }, result => {
      var _result$data21;
      return result === null || result === void 0 || (_result$data21 = result.data) === null || _result$data21 === void 0 ? void 0 : _result$data21.anonymousNewsletterPreferences;
    });
  });
  return function getMarketingPreferences(_x102, _x103, _x104, _x105) {
    return _ref41.apply(this, arguments);
  };
}();
var getSpendOverTimeCSV = exports.getSpendOverTimeCSV = function () {
  var _ref42 = (0, _asyncToGenerator2.default)(function* (token, accountNumber, fromMonthYear, toMonthYear, scheme, language) {
    if (!token || !accountNumber || !fromMonthYear || !toMonthYear || !scheme || !language) {
      return null;
    }
    var response = yield fetch("".concat(process.env.NEXT_PUBLIC_REST_API, "/v1/spending/accountSpending?pibaAccountId=").concat(accountNumber, "&fromMonthYear=").concat(fromMonthYear, "&toMonthYear=").concat(toMonthYear, "&scheme=").concat(scheme, "&language=").concat(language), {
      method: 'GET',
      headers: {
        Authorization: "Bearer ".concat(token),
        'WB-Authorization': "Bearer ".concat(token),
        accept: 'text/csv'
      },
      cache: 'no-cache'
    });
    if (!response.ok) {
      throw new Error("Failed to fetch CSV: ".concat(response.statusText));
    }
    var contentDisposition = response.headers.get('content-disposition');
    var filename = (contentDisposition === null || contentDisposition === void 0 ? void 0 : contentDisposition.split('filename=')[1]) || 'Inn Business Pay Spend Over Time';
    var blob = yield response.blob();
    (0, _.resolveAndDownloadBlob)(blob, filename, '');
  });
  return function getSpendOverTimeCSV(_x106, _x107, _x108, _x109, _x110, _x111) {
    return _ref42.apply(this, arguments);
  };
}();
var getAccountSpending = exports.getAccountSpending = function () {
  var _ref43 = (0, _asyncToGenerator2.default)(function* (token, fromMonthYear, toMonthYear, pibaAccountId, tetheredUserGuid) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token || !fromMonthYear || !toMonthYear || !pibaAccountId) {
      return null;
    }
    var response = yield (0, _.executeGraphQLQuery)((0, _api.getAccountSpendingQuery)(), {
      accountSpendingCriteria: {
        fromMonthYear,
        toMonthYear,
        pibaAccountId,
        tetheredUserGuid
      }
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getAccountSpending(_x112, _x113, _x114, _x115, _x116) {
    return _ref43.apply(this, arguments);
  };
}();
var getOutOfPolicyReport = exports.getOutOfPolicyReport = function () {
  var _ref44 = (0, _asyncToGenerator2.default)(function* (token, companyId, fromDate, toDate) {
    if (!token || !companyId || !fromDate || !toDate) {
      return null;
    }
    try {
      yield fetch("".concat(process.env.NEXT_PUBLIC_REST_API, "/companies/admin/").concat(companyId, "/reports/out-of-office?fromDate=").concat(fromDate, "&toDate=").concat(toDate), {
        method: 'GET',
        headers: {
          Authorization: "Bearer ".concat(token)
        },
        cache: 'no-cache'
      }).then(data => data.blob()).then(response => (0, _.resolveAndDownloadBlob)(response, 'OutOfPolicyReport', '.csv'));
    } catch (error) {
      return null;
    }
  });
  return function getOutOfPolicyReport(_x117, _x118, _x119, _x120) {
    return _ref44.apply(this, arguments);
  };
}();
var getIBActivationDetails = exports.getIBActivationDetails = function () {
  var _ref45 = (0, _asyncToGenerator2.default)(function* (activationKey) {
    try {
      var res = yield (0, _.executeGraphQLQuery)((0, _api.getIBActivationDetailsQuery)(), {
        activationKey
      }, result => {
        var _result$data22;
        return result === null || result === void 0 || (_result$data22 = result.data) === null || _result$data22 === void 0 ? void 0 : _result$data22.getInnBusinessActivationDetails;
      }, '', true, true);
      return res;
    } catch (error) {
      console.error('Error fetching IB activation details');
    }
  });
  return function getIBActivationDetails(_x121) {
    return _ref45.apply(this, arguments);
  };
}();
var getEmployeesWithFilteringOptions = exports.getEmployeesWithFilteringOptions = function () {
  var _ref46 = (0, _asyncToGenerator2.default)(function* (companyId, size, token, page, searchCriteria, pageToken, bookingChannel, awaitingApproval, shouldFilterEmployees) {
    return yield (0, _.executeGraphQLQuery)((0, _api.getEmployeesWithFilteringOptionsQuery)(), {
      companyId,
      size,
      page,
      searchCriteria,
      pageToken,
      bookingChannel,
      awaitingApproval,
      shouldFilterEmployees
    }, result => {
      var _result$data23;
      return result === null || result === void 0 || (_result$data23 = result.data) === null || _result$data23 === void 0 ? void 0 : _result$data23.getEmployeesWithFilteringOptions;
    }, token, true);
  });
  return function getEmployeesWithFilteringOptions(_x122, _x123, _x124, _x125, _x126, _x127, _x128, _x129, _x130) {
    return _ref46.apply(this, arguments);
  };
}();
var getBusinessBookerIpHeaders = headers => {
  var _headers$xForwarded, _headers$TrueClient;
  return {
    'x-forwarded-for': String((_headers$xForwarded = headers['x-forwarded-for']) !== null && _headers$xForwarded !== void 0 ? _headers$xForwarded : ''),
    'True-Client-IP': String((_headers$TrueClient = headers['True-Client-IP']) !== null && _headers$TrueClient !== void 0 ? _headers$TrueClient : '')
  };
};
exports.getBusinessBookerIpHeaders = getBusinessBookerIpHeaders;
var appPreCheck = exports.appPreCheck = function () {
  var _ref47 = (0, _asyncToGenerator2.default)(function* (token, scheme) {
    var _response$data$appPre, _response$data;
    var revalidateCache = false;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield (0, _.executeGraphQLQuery)((0, _api.appPreCheckQuery)(), {
      scheme
    }, result => result, token, revalidateCache, returnErrors);
    return (_response$data$appPre = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.appPreCheck) !== null && _response$data$appPre !== void 0 ? _response$data$appPre : null;
  });
  return function appPreCheck(_x131, _x132) {
    return _ref47.apply(this, arguments);
  };
}();
var getEmployeeDataforUserPilot = exports.getEmployeeDataforUserPilot = function () {
  var _ref48 = (0, _asyncToGenerator2.default)(function* (token) {
    if (!token) {
      return null;
    }
    try {
      var _companyDetails$reque, _companyDetails$reque2, _companyDetails$reque3, _companyDetails$reque4;
      var {
        companyId,
        employeeId,
        accessLevel
      } = getDetailsFromToken(token);
      var [accounts, companyDetails] = yield Promise.all([getAccountList(token), getCompanyDetails(companyId, token, false)]);
      var userPilotData = {
        role: accessLevel !== null && accessLevel !== void 0 ? accessLevel : '',
        innBusinessPayRoles: getAllPayRoles(accounts),
        employeeId: employeeId !== null && employeeId !== void 0 ? employeeId : '',
        companyId: companyId !== null && companyId !== void 0 ? companyId : '',
        companySector: (_companyDetails$reque = companyDetails === null || companyDetails === void 0 || (_companyDetails$reque2 = companyDetails.requestedCompany) === null || _companyDetails$reque2 === void 0 || (_companyDetails$reque2 = _companyDetails$reque2.companyDetails) === null || _companyDetails$reque2 === void 0 ? void 0 : _companyDetails$reque2.companySector) !== null && _companyDetails$reque !== void 0 ? _companyDetails$reque : '',
        numberOfEmployees: (_companyDetails$reque3 = companyDetails === null || companyDetails === void 0 || (_companyDetails$reque4 = companyDetails.requestedCompany) === null || _companyDetails$reque4 === void 0 || (_companyDetails$reque4 = _companyDetails$reque4.companyDetails) === null || _companyDetails$reque4 === void 0 ? void 0 : _companyDetails$reque4.numberOfEmployees) !== null && _companyDetails$reque3 !== void 0 ? _companyDetails$reque3 : 0
      };
      return userPilotData;
    } catch (_unused4) {
      return null;
    }
  });
  return function getEmployeeDataforUserPilot(_x133) {
    return _ref48.apply(this, arguments);
  };
}();
var getDetailsFromToken = token => {
  var _profile;
  var decodedToken = (0, _decodeIdToken.default)(token);
  var companyId = decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken[TOKEN_COMPANY_FIELD];
  var employeeId = decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken[TOKEN_EMPLOYEE_FIELD];
  var email = decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken[TOKEN_EMAIL_FIELD];
  var accessLevel = decodedToken === null || decodedToken === void 0 || (_profile = decodedToken.profile) === null || _profile === void 0 ? void 0 : _profile.accessLevel;
  var profile = (decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.profile) || {};
  return {
    companyId,
    employeeId,
    email,
    accessLevel,
    profile,
    isTravelManager: accessLevel === _api.BUSINESS_BOOKER_USER_ROLES.SUPER,
    isBooker: accessLevel === _api.BUSINESS_BOOKER_USER_ROLES.BOOKER,
    isSelfBooker: accessLevel === _api.BUSINESS_BOOKER_USER_ROLES.SELF,
    isGuest: accessLevel === _api.BUSINESS_BOOKER_USER_ROLES.STAYER
  };
};
exports.getDetailsFromToken = getDetailsFromToken;
var getStatementsPdf = exports.getStatementsPdf = function () {
  var _ref49 = (0, _asyncToGenerator2.default)(function* (token, tetheredUserGuid, schemeCustomerId, fileAutoID, statementDate, invoiceNo) {
    if (!token || !tetheredUserGuid || !schemeCustomerId || !fileAutoID || !statementDate || !invoiceNo) {
      return null;
    }
    var response = yield fetch("".concat(process.env.NEXT_PUBLIC_REST_API, "/piba/account/invoices/download/").concat(schemeCustomerId, "/").concat(tetheredUserGuid, "/").concat(fileAutoID), {
      method: 'GET',
      headers: {
        Authorization: "Bearer ".concat(token),
        'WB-Authorization': "Bearer ".concat(token),
        accept: 'application/pdf'
      },
      cache: 'no-cache'
    });
    if (!response.ok) {
      throw new Error("Failed to fetch PDF");
    }
    var filename = "Invoice_".concat(invoiceNo, "_").concat(statementDate);
    var blob = yield response.blob();
    (0, _.resolveAndDownloadBlob)(blob, filename, '.pdf');
  });
  return function getStatementsPdf(_x134, _x135, _x136, _x137, _x138, _x139) {
    return _ref49.apply(this, arguments);
  };
}();